import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "@redux/hooks";
import { useToast } from "@shared-kernel/primary/shared/shadcn/ui/use-toast";
import { resetOnboardStudent } from "@user-management-context/write/application/use-cases/student-onboarding/onboard-student-reducer";
import { selectStudentOnboarding } from "@user-management-context/write/application/use-cases/student-onboarding/selectors/student-onboarding-selectors";

export const useStudentOnboarding = () => {
  const { toast } = useToast();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { processing } = useAppSelector(selectStudentOnboarding);

  useEffect(() => {
    if (processing === "success") {
      toast({ description: "Votre profil élève est prêt !" });
      dispatch(resetOnboardStudent());
      navigate("/onboarding");
    } else if (processing === "failed") {
      toast({ description: "Erreur lors de la finalisation de votre profil élève", variant: "destructive" });
      dispatch(resetOnboardStudent());
    }
  }, [processing, toast, dispatch, navigate]);
};
